import { useMemo, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { PERMISSIONS } from "constants/portal";
import { permissionChecker } from "helpers/common";

export const useConnectorPermissions = (component) => {
  const { user } = useAuth0();
  const { userPermissions } = useContext(PermissionsContext);
  const { sharedConnectors } = useSelector((store) => store?.portal?.connectors);

  const permissions = useMemo(() => {
    if (!user || !component) {
      return {
        canEdit: false,
        canDelete: false,
        canShare: false,
        canOpenMenu: false,
        isOwner: false,
        isEditor: false
      };
    }

    const isOwner = component?.created_by_id === user?.cxfUserId;
    const sharedConnector = sharedConnectors.find(
      (sc) => sc.connector_id === component.id && sc.shared_user_id === user?.cxfUserId
    );
    const isEditor = sharedConnector?.access_type === "editor";

    const canEdit =
      permissionChecker(userPermissions, PERMISSIONS.EDIT_ANY_CONNECTORS) ||
      ((isOwner || isEditor) && permissionChecker(userPermissions, PERMISSIONS.EDIT_CONNECTORS));

    const canDelete =
      permissionChecker(userPermissions, PERMISSIONS.DELETE_ANY_CONNECTORS) ||
      (isOwner && permissionChecker(userPermissions, PERMISSIONS.DELETE_CONNECTORS));

    const canShare =
      permissionChecker(userPermissions, PERMISSIONS.SHARE_ANY_CONNECTORS) ||
      (isOwner && permissionChecker(userPermissions, PERMISSIONS.SHARE_CONNECTORS));

    return {
      canEdit,
      canDelete,
      canShare,
      canOpenMenu: canEdit || canDelete || canShare,
      isOwner,
      isEditor
    };
  }, [user, component, userPermissions, sharedConnectors]);

  return permissions;
};
